import { render, staticRenderFns } from "./CobaSimpleTable.vue?vue&type=template&id=1239824b&scoped=true&"
import script from "./CobaSimpleTable.vue?vue&type=script&lang=js&"
export * from "./CobaSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./CobaSimpleTable.vue?vue&type=style&index=0&id=1239824b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1239824b",
  null
  
)

export default component.exports